<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line" v-if="queryData._ModifyObjectName === 'person'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权对象：</span>
        </div>
        <el-input v-model="personName" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line" v-else>
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权对象：</span>
        </div>
        <el-input v-model="enterpriseName" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电梯：</span>
        </div>
        <el-select disabled v-model="liftDeviceCode" size="small" style="width: 280px">
          <el-option v-for="item in liftDeviceList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" style="display: flex;justify-content: flex-start;align-items: top;">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权楼层：</span>
        </div>
        <div style="display: inline-block;width: 500px;">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedLevels" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="level in levelList" :label="level" :key="level">{{level}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/LadderControl'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nSuccess} from '../../../utils/notice'

  export default {
    components: {
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'authorize-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧梯控',
            name: 'ladder-device'
          }, {
            value: '授权乘梯',
          }]
        },
        mainTitle: '修改授权',
        subheading: '',
        checkAll: false,
        checkedLevels: [],
        defaultCheckedLevels: [],
        levelList: [],
        isIndeterminate: true,

        responsiblePersonList: [],
        liftDeviceList: [],

        code: '',
        liftDeviceName: '',
        liftDeviceCode: '',
        levels: '',
        gateWayDeviceName: '',
        gateWayDeviceCode: '',
        personName: '',
        personCode: '',
        enterpriseName: '',
        enterpriseCode: '',

        queryData: {}
      }
    },
    created () {
      this.getLiftDeviceList()
      this.queryData = JSON.parse(this.$route.params.id);
      // this.getResponsiblePersonList()
    },
    methods: {
      // 获取电梯列表
      getLiftDeviceList () {
        api.getLiftDeviceList()
          .then(data => {
            let chooseLiftDeviceList = []
            this.liftDeviceList = data
            this.liftDeviceList.map(v => {
              if (v.code === this.queryData.liftDeviceCode) {
                if (v.startLevel > v.endLevel) {
                  let tem = v.startLevel
                  v.startLevel = v.endLevel
                  v.endLevel = tem
                }
                chooseLiftDeviceList.push(v)
              }
            })
            // console.log(chooseLiftDeviceList[0], 'chooseLiftDeviceList[0]', this.queryData.levels.split(','));
            let levelLength = this.queryData.levels.split(',').length;
            if (chooseLiftDeviceList[0] && chooseLiftDeviceList[0].endLevel == this.queryData.levels.split(',')[levelLength-1] && chooseLiftDeviceList[0].startLevel == this.queryData.levels.split(',')[0]) {
              this.checkAll = true;
              this.isIndeterminate = false;
            } else {
              this.checkAll = false;
              this.isIndeterminate = true;
            }
            this.code = this.queryData.code
            this.liftDeviceName = this.queryData.liftDeviceName
            this.liftDeviceCode = this.queryData.liftDeviceCode
            this.levels = this.queryData.levels
            this.gateWayDeviceName = this.queryData.gateWayDeviceName
            this.gateWayDeviceCode = this.queryData.gateWayDeviceCode
            this.personName = this.queryData.personName
            this.personCode = this.queryData.personCode
            this.enterpriseName = this.queryData.enterpriseName
            this.enterpriseCode = this.queryData.enterpriseCode

            if (this.queryData.levels.indexOf(',') === -1) {
              this.defaultCheckedLevels = [this.queryData.levels]
            } else {
              this.defaultCheckedLevels = this.queryData.levels.split(',')
            }
          })
          .catch(errorHandler('获取电梯列表失败'))
      },

      getResponsiblePersonList (searchKey) {
        api.getPersonList(searchKey || '')
          .then(list => {
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
            })
            this.responsiblePersonList = list
          })
      },
      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      confirm () {
        let obj = {
          code: this.code,
          liftDeviceName: this.liftDeviceName,
          liftDeviceCode: this.liftDeviceCode,
          levels: this.checkedLevels.join(','),
          gateWayDeviceName: this.gateWayDeviceName,
          gateWayDeviceCode: this.gateWayDeviceCode,
          personName: this.personName,
          personCode: this.personCode,
          enterpriseName: this.enterpriseName,
          enterpriseCode: this.enterpriseCode
        }
        if (this.queryData._ModifyObjectName === 'person') {
          api.updateLiftAuthority(obj)
            .then(() => {
              nSuccess('修改成功')
              this.strategyCenter()
            })
            .catch(errorHandler('修改失败'))
        } else {
          api.updateLiftAuthorityForEnterprise(obj)
            .then(() => {
              nSuccess('修改成功')
              this.strategyCenter()
            })
            .catch(errorHandler('修改失败'))
        }
      },
      strategyCenter () {
        this.$router.push({
          name: 'elevator-authorize'
        })
      },

      handleCheckAllChange(val) {
        this.checkedLevels = val ? this.levelList : []
        this.isIndeterminate = false
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.levelList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.levelList.length;
      }
    },
    watch: {
      personCode (val) {
        this.responsiblePersonList.map(v => {
          if (v.code === this.personCode) {
            this.personName = v.name
            this.enterpriseName = v.enterpriseName
            this.enterpriseCode = v.enterpriseCode
          }
        })
      },
      liftDeviceCode (val) {
        this.liftDeviceList.map(v => {
          if (v.code === val) {
            this.gateWayDeviceCode = v.relateGatewayCode
            this.gateWayDeviceName = v.relateGatewayName
            this.liftDeviceName = v.name
            if (v.startLevel > v.endLevel) {
              let tem = v.startLevel
              v.startLevel = v.endLevel
              v.endLevel = tem
            }
            this.checkedLevels = []
            if (this.defaultCheckedLevels) {
              this.checkedLevels = this.defaultCheckedLevels
              this.defaultCheckedLevels = []
            }
            let levelList = []
            for (let i = v.startLevel; i < v.endLevel + 1; i++) {
              if (i !== 0) {
                levelList.push(i.toString())
              }
            }
            this.levelList = levelList
          }
        })
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .form-line {
    .el-checkbox {
      margin-left: 0!important;
      margin-right: 30px;
    }
    .el-checkbox__label {
      width: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/Authorize/AuthorizeModify.vue